export default __webpack_public_path__ + "static/media/Group-925.d4a371b3.svg";